module.exports = __webpack_public_path__ + "static/img/fourth4.389ec52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fourth4.png
// module id = TkCY
// module chunks = 25